import Image from 'global/Image';
import { ValuePointIconItem } from './styled';

interface IValuePointIconProps {
  icon: string;
  text: (string | JSX.Element)[];
}

const ValuePointIcon = ({ icon, text }: IValuePointIconProps) => (
  <ValuePointIconItem>
    <Image src={icon} />
    <span>{text}</span>
  </ValuePointIconItem>
);
export default ValuePointIcon;
